'use client'

import React, { CSSProperties, ReactNode } from "react";
import { StyledItemsGrouped } from "./ItemsGrouped.styles";

interface ItemsGroupedProps {
  children: ReactNode;
  direction?: string | Record<string, string>;
  space?: number | Record<string, number>;
  isWrap?: boolean;
  fullWidth?: boolean | string[];
  style?: CSSProperties;
  align?: string | Record<string, string>;
  justify?: string | Record<string, string>;
}

const ItemsGrouped = ({ 
  children, 
  direction, 
  space,
  isWrap, 
  fullWidth, 
  style, 
  align, 
  justify
}: ItemsGroupedProps) => {
  return (
    <StyledItemsGrouped 
      $direction={direction} 
      space={space} 
      isWrap={isWrap} 
      fullWidth={fullWidth} 
      style={style} 
      align={align}
      justify={justify}
    >
      {children}
    </StyledItemsGrouped>
  );
};

ItemsGrouped.displayName = 'Items Grouped';

export default ItemsGrouped;
